import { MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';

import { environment } from 'src/environments/environment';

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[] | null>(
    environment.msal.protectedResourceMap
  );

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: protectedResourceMap as Map<string, string[]>,
  };
}
